import { useNavigate } from "react-router-dom";
import { Palette, Rocket, Users } from "lucide-react";
import { Card } from "@/components/ui/card";
import { useNoIndex } from "@/hooks/useNoIndex";

const InternalHome = () => {
  useNoIndex();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background flex flex-col items-center justify-center p-6">
      <div className="w-full max-w-3xl space-y-10">
        <div className="text-center space-y-3">
          <h1 className="text-4xl md:text-5xl font-heading font-bold gradient-text">
            Dibs internal
          </h1>
          <p className="text-muted-foreground font-body">
            Internal tools — for the Dibs team only.
          </p>
        </div>

        <div className="grid gap-6 sm:grid-cols-2">
          <Card
            role="button"
            tabIndex={0}
            onClick={() => navigate("/design")}
            onKeyDown={(e) => e.key === "Enter" && navigate("/design")}
            className="module-card cursor-pointer transition-all hover:shadow-card-hover hover:-translate-y-1 flex flex-col items-center text-center gap-4 py-10"
          >
            <div className="h-14 w-14 rounded-xl bg-secondary flex items-center justify-center">
              <Palette className="h-7 w-7 text-primary" />
            </div>
            <div className="space-y-1">
              <h2 className="text-xl font-heading font-semibold">Design.md</h2>
              <p className="text-sm text-muted-foreground">
                Interactive design system & component showcase
              </p>
            </div>
          </Card>

          <Card
            role="button"
            tabIndex={0}
            onClick={() => navigate("/onboarding")}
            onKeyDown={(e) => e.key === "Enter" && navigate("/onboarding")}
            className="module-card cursor-pointer transition-all hover:shadow-card-hover hover:-translate-y-1 flex flex-col items-center text-center gap-4 py-10"
          >
            <div className="h-14 w-14 rounded-xl bg-secondary flex items-center justify-center">
              <Rocket className="h-7 w-7 text-primary" />
            </div>
            <div className="space-y-1">
              <h2 className="text-xl font-heading font-semibold">
                Business Onboarding
              </h2>
              <p className="text-sm text-muted-foreground">
                Guided wizard to onboard a new client on a demo call
              </p>
            </div>
          </Card>

          <Card
            role="button"
            tabIndex={0}
            onClick={() => navigate("/collaborator-access")}
            onKeyDown={(e) => e.key === "Enter" && navigate("/collaborator-access")}
            className="module-card cursor-pointer transition-all hover:shadow-card-hover hover:-translate-y-1 flex flex-col items-center text-center gap-4 py-10"
          >
            <div className="h-14 w-14 rounded-2xl bg-secondary flex items-center justify-center">
              <Users className="h-7 w-7 text-primary" />
            </div>
            <div className="space-y-1">
              <h2 className="text-xl font-heading font-semibold">Collaborator Access</h2>
              <p className="text-sm text-muted-foreground">
                Add Dibs as a 3-day collaborator — owner approves once
              </p>
            </div>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default InternalHome;
